(() => {
  const balanceFlashGallery = (page, details, media) => {
    if (page._rybFjLeftGallery) { page._rybFjLeftGallery(); return; }
    let queued = false;
    const update = () => {
      queued = false;
      const grid = media.querySelector('.media-gallery__grid');
      const frames = [...(grid?.children || [])];
      if (!grid || !frames.length) return;
      if (media.matches('[data-ryb-grub45-natural],[data-ryb-grub3-natural]') || media.querySelector('media-gallery[data-ryb-grub45-natural],media-gallery[data-ryb-grub3-natural]')) {
        frames.forEach(frame => {
          frame.style.removeProperty('--ryb-fj-frame-height');
          frame.style.removeProperty('--ryb-fj-photo-fit');
        });
        return;
      }
      if (!window.matchMedia('(min-width: 750px)').matches) {
        frames.forEach(frame => {
          frame.style.removeProperty('--ryb-fj-frame-height');
          frame.style.removeProperty('--ryb-fj-photo-fit');
        });
        return;
      }
      const width = grid.getBoundingClientRect().width;
      const mediaStyle = getComputedStyle(media);
      const chrome = ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth']
        .reduce((sum, key) => sum + (parseFloat(mediaStyle[key]) || 0), 0);
      const gap = parseFloat(getComputedStyle(grid).rowGap) || 12;
      const note = media.querySelector('[data-ryb-photo-notice]');
      const noteHeight = note ? note.getBoundingClientRect().height + 12 : 0;
      const target = details.getBoundingClientRect().height - chrome - noteHeight - gap * (frames.length - 1);
      const firstHeight = width * 0.8;
      if (page.hasAttribute('data-ryb-fj-watermelon') && frames.length === 3) {
        const otherHeight = Math.max(120, (target - firstHeight) / 2);
        const heights = [firstHeight, otherHeight, otherHeight];
        frames.forEach((frame, index) => {
          frame.style.setProperty('--ryb-fj-frame-height', heights[index].toFixed(2) + 'px');
          frame.style.setProperty('--ryb-fj-photo-fit', 'contain');
        });
        return;
      }
      const rest = frames.slice(1);
      const naturalHeights = rest.map(frame => {
        const ratio = parseFloat(frame.style.getPropertyValue('--media-preview-ratio')) || 0.75;
        return width / ratio;
      });
      const totalNatural = naturalHeights.reduce((sum, h) => sum + h, 0);
      frames[0].style.setProperty('--ryb-fj-frame-height', firstHeight.toFixed(2) + 'px');
      frames[0].style.setProperty('--ryb-fj-photo-fit', 'contain');
      rest.forEach((frame, index) => {
        const height = Math.max(120, (target - firstHeight) * naturalHeights[index] / totalNatural);
        frame.style.setProperty('--ryb-fj-frame-height', height.toFixed(2) + 'px');
        frame.style.setProperty('--ryb-fj-photo-fit', 'cover');
      });
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    page._rybFjLeftGallery = schedule;
    const observer = new ResizeObserver(schedule);
    observer.observe(details);
    observer.observe(media);
    document.fonts?.ready.then(schedule);
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  };
  const start = () => {
    const options = document.querySelector('.ryb-mj-options[data-ryb-hard-lures]') || document.querySelector('[data-ryb-meteora-standard]:not([data-ryb-mj-legacy])');
    if (!options) return;
    const host = options.closest('.shopify-section');
    const page = host?.querySelector('.product-information');
    const grid = page?.querySelector('.product-information__grid');
    const details = grid?.querySelector('.product-details');
    const panel = details?.querySelector(':scope > .group-block > .group-block-content');
    if (!grid || !panel) return; // W razie niezgodnego motywu pozostaje działający oryginał.
    if (options.hasAttribute('data-ryb-hard-lures')) {
      page.setAttribute('data-ryb-hard-lures', '');
      if (options.hasAttribute('data-ryb-handoff-layout')) host.querySelectorAll('[data-ryb-nd-colors],.ryb-shared-color-module,[data-ryb-smith-dc-colors]').forEach(old => { old.hidden=true; old.setAttribute('data-ryb-mj-legacy',''); old.style.setProperty('display','none','important'); });
      host.querySelectorAll('[data-ryb-meteora-standard]').forEach(old => { if (old !== options) { old.hidden = true; old.setAttribute('data-ryb-mj-legacy', ''); } });
      host.querySelectorAll('aside[class*="guide"],section[class*="guide"]').forEach(old => { if (!old.hasAttribute('data-ryb-hard-guide')) { old.hidden = true; old.setAttribute('data-ryb-mj-legacy', ''); } });
    }
    page.classList.add('ryb-mj-page');
    details.classList.add('ryb-mj-details');
    details.querySelector(':scope > .group-block')?.classList.add('ryb-mj-panel');
    const firstBuy = panel.querySelector('product-form-component');
    let anchor = firstBuy;
    while (anchor && anchor.parentElement !== panel) anchor = anchor.parentElement;
    if (anchor) panel.insertBefore(options, anchor); else panel.append(options);
    const oldModules = panel.querySelectorAll('.ryb-boroda-color-variants,.ryb-magic-color-variants,.ryb-righetti-colors,.ryb-megabass-colors,.ryb-hazedong-controls,.ryb-haz3-colors,.ryb-haz4-colors,.ryb-haz5-colors,.ryb-damiki-standard-colors,.ryb-d-incite-colors,.ryb-x-zone-colors');
    oldModules.forEach(module => { module.hidden = true; module.setAttribute('data-ryb-mj-legacy', ''); });
    let guide = options.hasAttribute('data-ryb-hard-lures') ? host.querySelector('[data-ryb-hard-guide]') : host.querySelector('[data-ryb-mj-guide]:not([data-ryb-mj-legacy])');
    const oldGuides = [...panel.querySelectorAll('section[class*="guide"],aside[class*="guide"]')];
    if (!guide) guide = oldGuides.find(el => !el.hidden && getComputedStyle(el).display !== 'none');
    oldGuides.forEach(el => { if (el !== guide) { el.hidden = true; el.setAttribute('data-ryb-mj-legacy', ''); } });
    if (guide) { guide.classList.add('ryb-mj-guide'); grid.append(guide); }
    const description = host.querySelector('[data-ryb-handoff-description]') || page.querySelector('.ryb-product-description-under-media');
    if (options.hasAttribute('data-ryb-handoff-layout')) host.querySelectorAll('.ryb-product-description-under-media').forEach(old => { if (old !== description) { old.hidden = true; old.setAttribute('data-ryb-mj-legacy', ''); } });
    if (description) { description.classList.add('ryb-mj-description'); grid.append(description); }
    const colorGrid = options.querySelector('.ryb-mj-colors');
    const count = colorGrid.children.length;
    colorGrid.style.setProperty('--ryb-mj-color-columns', String(Math.min(6, Math.max(1, count))));
    if (count === 0) options.querySelector('.ryb-mj-selected').textContent = 'Wybierz wariant produktu poniżej.';
    // Formularz i identyfikator produktu Shopify zostają oryginalne; zmieniamy tylko miejsce prezentacji.
    const waitlist = panel.querySelector('[data-ryb-back-in-stock-form]:not([hidden])');
    if (waitlist && anchor) panel.insertBefore(waitlist, anchor.nextSibling);
    page.querySelectorAll('[data-ryb-righetti-gallery-duplicate]').forEach(el => el.remove());
    const title = panel.querySelector('h1');
    const price = panel.querySelector('product-price');
    if (title && options.dataset.rybJacksonTitle) title.textContent = options.dataset.rybJacksonTitle;
    if (title && price) {
      let titleRow = title.parentElement;
      while (titleRow && titleRow !== panel && !titleRow.contains(price)) titleRow = titleRow.parentElement;
      if (titleRow && titleRow !== panel) titleRow.classList.add('ryb-mj-title-price');
    }
    const selected = options.querySelector('.ryb-mj-selected strong');
    if (selected && title && selected.textContent.trim() === title.textContent.trim()) {
      const full = title.textContent.trim();
      if (full.includes('#')) selected.textContent = '#' + full.split('#').at(-1).split(' — ')[0].split('/')[0].trim();
      else if (full.includes(' — ')) selected.textContent = full.split(' — ').at(-1);
    }
    if (new URLSearchParams(location.search).get('wybierz_kolor') === '1') {
      options.querySelector('.ryb-mj-selected').textContent = 'Poprzedni kolor nie występuje w tym rozmiarze. Wybierz kolor ze zdjęć poniżej.';
      options.querySelectorAll('[aria-current]').forEach(el => { if (el.classList.contains('ryb-mj-color')) el.removeAttribute('aria-current'); });
      panel.querySelectorAll('product-form-component button[type="submit"]').forEach(button => { button.disabled = true; button.textContent = 'Najpierw wybierz kolor'; });
      if (waitlist) waitlist.hidden = true;
      if (options.dataset.explicitChoice !== 'true') {
        options.dataset.explicitChoice = 'true';
        options.addEventListener('click', event => {
          const colorLink = event.target.closest('a.ryb-mj-color');
          if (!colorLink) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign(colorLink.href);
        }, true);
      }
    }
    const picker = panel.querySelector('variant-picker');
    const variantInputs = picker?.querySelectorAll('input[type="radio"],select');
    if (variantInputs?.length === 1) picker.setAttribute('data-ryb-mj-single-variant', '');
    // Flash-J 2: niezależne kolumny bez pustego wspólnego rzędu.
    if (options.hasAttribute('data-ryb-flash-j-2') || options.hasAttribute('data-ryb-left-gallery')) {
      page.setAttribute('data-ryb-flash-j-2-compact', '');
      if (options.dataset.rybProductId === '11316197458263') page.setAttribute('data-ryb-fj-watermelon', '');
      page.setAttribute('data-ryb-fj-left-gallery', '');
      page.style.removeProperty('--ryb-fj-guide-extra');
      let left = grid.querySelector(':scope > .ryb-fj-left-column');
      if (!left) {
        left = document.createElement('div');
        left.className = 'ryb-fj-left-column';
        grid.prepend(left);
      }
      const media = page.querySelector('.product-information__media');
      if (media) left.append(media);
      const photoNotice = options.querySelector('[data-ryb-photo-notice]');
      if (media && photoNotice) { photoNotice.style.cssText = 'margin:0 0 12px;padding:12px;border:1px solid #ddd;border-radius:8px;line-height:1.4;background:#faf8f2'; media.prepend(photoNotice); }
      if (description) details.append(description);
      if (guide) details.append(guide);
      if (media) balanceFlashGallery(page, details, media);

    }
    page.dataset.rybMjReady = 'true';
  };
  start();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  window.addEventListener('load', start, {once:true});
  document.addEventListener('shopify:section:load', start);
})();


